<template>
  <div class="main-content">
    <!-- <button class="consent-button" @click="showConsent = true">Banner</button> -->
    <b-modal
      v-model="showConsent"
      centered
      hide-header-close
      hide-footer
      hide-header
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div class="consent-text">
        <div class="consent-title">We value your privacy</div>
        <div class="consent-body">
          We use cookies and other tracking technologies to improve your
          experience on our website. We may store and/or access information on a
          device and process personal data, such as your IP address and browsing
          data, for personalized advertising and content, advertising and
          content measurement, audience research and services development.<br />
          Additionally, we may utilize precise geolocation data and
          identification through device scanning. To learn more, please review
          our
          <a
            href="https://www.dripcapital.com/en-in/privacy-policy"
            target="_blank"
          >
            Privacy Policy </a
          >.
        </div>
      </div>
      <div class="d-flex align-items-center">
        <button
          id="deny-button"
          class="consent-cta-button deny-button"
          @click="denyConsent"
        >
          Reject All
        </button>
        <button
          id="accept-button"
          class="consent-cta-button accept-button"
          @click="acceptConsent"
        >
          Accept All
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showConsent: false
    }
  },
  mounted() {
    if (
      !['AcceptAll', 'RejectAll'].includes(
        this.$consentManager.getConsentValue('preference')
      )
    ) {
      this.showConsent = true
    }
  },
  methods: {
    acceptConsent() {
      this.$consentManager.setConsent('preference', 'AcceptAll')
      this.$emit('triggerLocalCookie')
      this.showConsent = false
    },
    denyConsent() {
      this.$consentManager.setConsent('preference', 'RejectAll')
      this.showConsent = false
    }
  }
}
</script>
<style lang="scss">
.main-content {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 9;

  .consent-button {
    position: absolute;
    font-size: 14px;
    font-weight: 700;
    left: 50px;
    bottom: 50px;
    width: 100px;
    height: 39px;
    padding: 5px;
    border-radius: 23px;
    border: 0;
    box-shadow: 0 4px 22px 1px #6e6e6e;
    background: #0a273f;
    color: white;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
}

.consent-cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 40px;
  padding: 10px;
  border-radius: 25px;
  outline: none;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Nunito Sans';

  &:hover {
    box-shadow: 0 4px 18px -9px rgb(21 15 74);
  }

  &.deny-button {
    border: 2px solid #0a273f;
    background: white;
    color: #0a273f;
    margin-left: auto;
  }

  &.accept-button {
    border: 2px solid #0a273f;
    background: #0a273f;
    color: white;
    margin-left: 12px;
  }
}
</style>
<style lang="scss">
.modal-body {
  padding: 16px 30px !important;

  .consent-title {
    font-size: 20px;
    font-weight: bold;
    color: #0a273f;
    margin-bottom: 8px;
    font-family: 'Nunito Sans';
  }

  .consent-body {
    font-size: 16px;
    font-family: 'Nunito Sans';
    color: #0a273f;
    margin-bottom: 16px;
  }
}
</style>
